import { FormValues } from "@/models/proposalForm.model";
import { createContext, useContext, ReactNode, useState } from "react";

interface FormContextType {
  formData: FormValues;
  updateFormData: (
    step: keyof FormValues,
    values: Partial<FormValues[keyof FormValues]>
  ) => void;
}

const FormContext = createContext<FormContextType | undefined>(undefined);

export function useForm() {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error("useForm must be used within a FormProvider");
  }
  return context;
}

interface FormProviderProps {
  children: ReactNode;
}

export function FormProvider({ children }: FormProviderProps) {
  const [formData, setFormData] = useState<
    FormValues
  >({
    resultStep: {
      chosenFinancialOption: undefined,
      antecipatedYears: undefined,
    },
    personalData: {
      name: undefined,
      birthDate: undefined,
      cellphone: undefined,
      motherName: undefined,
    },
    address: {
      street: undefined,
      streetNumber: undefined,
      cep: undefined,
      district: undefined,
      complement: undefined,
      city: undefined,
      state: undefined,
    },
    bankData: {
      bankCode: undefined,
      paymentType: undefined,
      pixType: undefined,
      pixKey: undefined,
      accountType: undefined,
      account: undefined,
      agency: undefined,
      digit: undefined,
    },
    proposal: undefined,
  });

  const updateFormData = (
    step: keyof FormValues,
    values: Partial<FormValues[keyof FormValues]>
  ) => {
    setFormData((prev) => ({
      ...prev,
      [step]: {
        ...prev[step],
        ...values,
      },
    }));
  };

  return (
    <FormContext.Provider value={{ formData, updateFormData }}>
      {children}
    </FormContext.Provider>
  );
}
